( function () {

    /**
     * Selpers simple quiz logic.
     * @author Mario Sassmann <mario.sassmann@speedy-space.com>
     */
    const quizcontainers = document.querySelectorAll( '.selpers-simple-quiz' );

    function quizOnClick() {
        if ( this.parentElement.classList.contains( 'done' ) ) {
            return false;
        }

        if ( this.classList.contains( 'correct-answer' ) ) {
            this.parentElement.querySelector( '.answer-text.correct' ).style.display = 'block';
        } else {
            this.parentElement.querySelector( '.answer-text.wrong' ).style.display = 'block';
        }
        this.parentElement.classList.add( 'done' );
        this.classList.add( 'checked' );

        // attach google event to track answered examples.
        if ( window.ga && ga.create ) {
            ga( 'send', {
                hitType: 'event',
                eventCategory: 'Kurse',
                eventAction: 'click',
                eventLabel: 'Quizfrage beantwortet bei "' + document.querySelector( 'h1' ).textContent + '"'
            } );
        }
    }

    // attach click event handler to checkboxes inside all quiz containers.
    for ( let container of quizcontainers ) {
        const answer_elements = container.querySelectorAll( '.checkbox' );

        for ( let elem of answer_elements ) {
            elem.addEventListener( 'click', quizOnClick );
        }
    }

} ) ();

